import { useAppHelper } from './app.helper';
import { AppDrawers, AppLoaders, AppModals, AppRouter } from './components';

export const App = () => {
	useAppHelper();

	return (
		<>
			<AppLoaders />
			<AppModals />
			<AppDrawers />
			<AppRouter />
		</>
	);
};
